import { Card, Button, BlockStack, Text, Banner } from '@shopify/polaris';
import { useResourceMutation } from '../../../shared/hooks/useResourceMutation';
import { testTntConnection, TntTestResult } from './api';

export function TntTestConnectionCard(): JSX.Element {
  const mutation = useResourceMutation<void, TntTestResult>((api) => testTntConnection(api));

  return (
    <Card>
      <BlockStack gap="300">
        <Text as="h2" variant="headingMd">Connection test</Text>
        <Text as="p" variant="bodyMd">
          Sends a synthetic rate request to the TNT RTT endpoint using the configured credentials.
        </Text>
        <Button
          onClick={() => mutation.mutate()}
          loading={mutation.isPending}
          variant="primary"
        >
          Test TNT connection
        </Button>
        {mutation.data ? (
          <Banner tone={mutation.data.success ? 'success' : 'critical'} title={mutation.data.success ? 'TNT reachable' : 'TNT test failed'}>
            <p>{mutation.data.message}</p>
            <p>Completed in {mutation.data.durationMs} ms.</p>
          </Banner>
        ) : null}
      </BlockStack>
    </Card>
  );
}
